import React, { useState, useEffect } from "react";
import { PostApi, GetApi, PutApi, getProfCliente, getDocCliente } from "../../services/auth.js";
import { Loading } from "../../helpers";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "../../componentes/ModalLegacy";
import { Cont } from "./styles";
import { Card, CardBody, Grid, Section, InputContainer, FormLabel, Alert, Container, CardFooter, CardHeader, List} from "uikit-react";
import { DateFormatTNew, visible, formatCnpjCpf, DataHoraFormatada, validaCPF, validarCNPJ } from "../../services/funcoes";
import ReactPaginate from 'react-paginate';
import Select from 'react-select'
import InputMask from 'react-input-mask';
import Swal from 'sweetalert2';

const Push = () => {
  const ListaStatus = [   
    { value: 1, label: 'Disparo Futuro' },
    { value: 2, label: 'Processando Base' },
    { value: 3, label: 'Processando Disparos' }, 
    { value: 4, label: 'Disparos Finalizados' }
  ];
  const ListaEstados = [
    { value: "AC", label: "Acre" },
    { value: "AL", label: "Alagoas" },
    { value: "AP", label: "Amapá" },
    { value: "AM", label: "Amazonas" },
    { value: "BA", label: "Bahia" },
    { value: "CE", label: "Ceará" },
    { value: "DF", label: "Distrito Federal" },
    { value: "ES", label: "Espírito Santo" },
    { value: "GO", label: "Goiás" },
    { value: "MA", label: "Maranhão" },
    { value: "MT", label: "Mato Grosso" },
    { value: "MS", label: "Mato Grosso do Sul" },
    { value: "MG", label: "Minas Gerais" },
    { value: "PA", label: "Pará" },
    { value: "PB", label: "Paraíba" },
    { value: "PR", label: "Paraná" },
    { value: "PE", label: "Pernambuco" },
    { value: "PI", label: "Piauí" },
    { value: "RJ", label: "Rio de Janeiro" },
    { value: "RN", label: "Rio Grande do Norte" },
    { value: "RS", label: "Rio Grande do Sul" },
    { value: "RO", label: "Rondônia" },
    { value: "RR", label: "Roraima" },
    { value: "SC", label: "Santa Catarina" },
    { value: "SP", label: "São Paulo" },
    { value: "SE", label: "Sergipe" },
    { value: "TO", label: "Tocantins" }
  ];
  const [ListaProfissoes, setListaProfissoes] = useState(false);
  const [ListaProfissoesSelecionadas, setListaProfissoesSelecionadas] = useState([]);
  const [ListaEstadosSelecionados, setListaEstadosSelecionados] = useState([]);
  const [ListaPush, setListaPush] = useState(false);
  const [TituloFiltro, setTituloFiltro] = useState("");
  const [StatusFiltro, setStatusFiltro] = useState(null);
  const [DataCadInicio, setDataCadInicio] = useState("");
  const [DataCadTermino, setDataCadTermino] = useState("");
  const [CNPJFiltro, setCNPJFiltro] = useState("");
  const [ModalCadastroPush, setModalCadastroPush] = useState(false);
  const [DadosCadastro, setDadosCadastro] = useState({});
  const [LoadingExportar, setLoadingExportar] = useState(false);

  //mensagem 
  const [mensagem, Setmensagem] = useState("Nenhuma informação encontrada. Por favor, verifique o filtro aplicado e tente novamente.");

  //Alert
  const [msg, SetMsg] = useState("");
  const [time, SetTime] = useState("");
  const [color, SetColor] = useState(""); //sucess, danger, warning
  const [AlertMsg, SetAlertMsg] = useState(false); 

  //Paginação
  const [itensPerPage, SetItensPerPage] = useState(25);
  const [currentPage, SetCurrentPage] = useState(1);
  const [pageCount, SetPageCount] = useState(0);
  const [pageTotal, SePageTotal] = useState(0);

  const MudaPaginaItens = async (e) => {  
    if(!isNaN(e.nextSelectedPage+1)){      
      SetCurrentPage(e.nextSelectedPage+1)
    }
  };
  
  useEffect(() => {  
    GetListaPush();
    window.scrollTo(0, 0); 
  },[currentPage, itensPerPage]);

  useEffect(() => {  
    console.log("ListaProfissoesSelecionadas: ", ListaProfissoesSelecionadas);
    console.log("ListaEstadosSelecionados: ", ListaEstadosSelecionados);
  },[ListaProfissoesSelecionadas, ListaEstadosSelecionados]);

  useEffect(() => {  
    GetListaProfissoes();
  },[]);
    
  const GetListaPush = async () => {  
    setListaPush(false);

    var FiltrosURL = "";
    if(TituloFiltro){
      FiltrosURL = FiltrosURL + "NomeCampanha=" + TituloFiltro.trim() + "&";
    }
    if(StatusFiltro){
      FiltrosURL = FiltrosURL + "StatusId=" + StatusFiltro.value + "&";
    }
    if(DataCadInicio){
      FiltrosURL = FiltrosURL + "DataCad=" + DataCadInicio + "&";
    }
    if(DataCadTermino){
      FiltrosURL = FiltrosURL + "DataEnvio=" + DataCadTermino + "&";
    }

    const response = await GetApi('Admin/push/?' + FiltrosURL + 'Pagina=' + currentPage + '&TamanhoPagina=' + itensPerPage );
    if (response.status === 200) {
      setListaPush(response.data.pushs);
			SetPageCount(Math.ceil(response.data.totalRegistros / itensPerPage));
			SePageTotal(response.data.totalRegistros)
    } else {
      setListaPush([])
      SetTime(4000);
      SetMsg(response.data.mensagem);
      SetColor("danger");
      SetAlertMsg(true);
    }     
    
  };

  const GetListaProfissoes = async () => {
    const response = await GetApi('Filtros?Cad_tipo=73&Cad_ativo=1');
    if (response.status === 200) {
      var _ListaProfissoes = [];
      for (var i = 0; i < response.data.filtros.length; i++) {
        if(response.data.filtros[i].cad_par01_texto !== "ADMINISTRATIVO"){
          _ListaProfissoes.push({
            value: response.data.filtros[i].cad_cod,
            label: response.data.filtros[i].cad_descricao
          });
        }
      }
      setListaProfissoes(_ListaProfissoes);
    }
  };

  const AbreModalCadastroPush = () => {
    setDadosCadastro({});
    setListaProfissoesSelecionadas([]);
    setListaEstadosSelecionados([]);
    setModalCadastroPush(true);
  };

  const FechaModalCadastroPush = () => {
    setDadosCadastro({});
    setListaProfissoesSelecionadas([]);
    setListaEstadosSelecionados([]);
    setModalCadastroPush(false);
  };

  const CadastrarPush = async () => {
    
    if(!DadosCadastro?.dataEnvio){
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "Por favor, informe uma data de envio.",
      });
      return;
    }

    var dataEnvio = new Date(DadosCadastro?.dataEnvio);
    var dataAtual = new Date();

    if(dataEnvio < dataAtual){
			Swal.fire({
				icon: "warning",
				title: "Atenção!",
				text: "Por favor, informe uma data de envio válida.",
			});
      return;
    }

    if(!DadosCadastro?.titulo){
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "Por favor, informe um título.",
      });
      return;
    }

    if(!DadosCadastro?.mensagem){
      Swal.fire({
        icon: "warning",
        title: "Atenton!",
        text: "Por favor, informe uma mensagem.",
      });
      return;
    }

		visible('btn-envia-formulario-loading');
    visible('btn-envia-formulario');

    var dados = {
      "nomeCampanha": DadosCadastro?.titulo,
      "mensagem": DadosCadastro?.mensagem,
      "dataEnvio": DadosCadastro?.dataEnvio,
      "estadosId": ListaEstadosSelecionados,
      "profissoesId": ListaProfissoesSelecionadas,
      "tipoId": 1,
      "pontosExpirar": false,
      "clustersId": [],
      "acaoId": null,
      "saldoIni": null,
      "saldoFim": null,
    }

    console.log('dados: ', dados);

    const response = await PostApi('Admin/push', dados);
    if (response.status === 200) {
      GetListaPush();
      SetTime(4000);
      SetMsg(response.data.mensagem);
      SetColor("success");
      SetAlertMsg(true);
      setModalCadastroPush(false);
      visible('btn-envia-formulario-loading');
      visible('btn-envia-formulario');
      setDadosCadastro({});
    } else {
      SetTime(4000);
      SetMsg(response.data.mensagem);
      SetColor("danger");
      SetAlertMsg(true);
      setModalCadastroPush(false);
      visible('btn-envia-formulario-loading');
      visible('btn-envia-formulario');
      setDadosCadastro({});
    }
  };

  const ExportarDados = async () => {

    var FiltrosURL = "";
    if(TituloFiltro){
      FiltrosURL = FiltrosURL + "NomeCampanha=" + TituloFiltro.trim() + "&";
    }
    if(StatusFiltro){
      FiltrosURL = FiltrosURL + "StatusId=" + StatusFiltro.value + "&";
    }
    if(DataCadInicio){
      FiltrosURL = FiltrosURL + "DataCad=" + DataCadInicio + "&";
    }
    if(DataCadTermino){
      FiltrosURL = FiltrosURL + "DataEnvio=" + DataCadTermino + "&";
    }

    setLoadingExportar(true);
    const response = await GetApi('Admin/push/excel?' + FiltrosURL + 'Pagina=' + currentPage + '&TamanhoPagina=' + itensPerPage );
    if (response.status === 200) {

    try {

      const base64 = response.data.arquivoExcel;
      const binaryString = window.atob(base64);
      const byteNumbers = new Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) { byteNumbers[i] = binaryString.charCodeAt(i); }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Push.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);

      SetTime(4000);
      SetMsg("Exportação concluída com sucesso!");
      SetColor("success");
      SetAlertMsg(true);
      setLoadingExportar(false);
    } catch (err) {
      console.error("Erro ao processar o Excel:", err);
      SetMsg("Erro ao processar o arquivo Excel.");
      SetColor("danger");
      SetAlertMsg(true);
      setLoadingExportar(false);
    }

      SetTime(4000);
      SetMsg("Exportação concluída com sucesso!");
      SetColor("success");
      SetAlertMsg(true);
      setLoadingExportar(false);
    } else {
      setLoadingExportar(false);
      SetTime(4000);
      SetMsg(response.data.mensagem);
      SetColor("danger");
      SetAlertMsg(true);
    }
  };

  return (
    <Cont>    

      <Container size="expand" className="content-padder content-padder-inative" id="padder" >            
        <main className="uk-section">
          <Section className="uk-container uk-container-xlarge">  

              <Grid className="uk-flex uk-flex-middle uk-margin-medium">                
                <Section className="uk-width-expand">
                  <Section className="uk-inline">
                    <a className="uk-link-heading uk-flex uk-flex-middle">
                      <h4 className="uk-link-toggle uk-text-bold uk-margin-remove"> Push </h4>
                    </a>
                  </Section>
                </Section>
              </Grid>  
                    
              <Card className="uk-margin-medium-bottom">
                <CardBody>
                  <Grid className="uk-grid-small">
                
                    <Section className="uk-width-1-2@m">
                      <FormLabel className="uk-form-label">Título</FormLabel>
                      <InputContainer>
                        <input
                          className="uk-input input"
                          type="text"
                          value={TituloFiltro}
                          onChange={e => setTituloFiltro(e.target.value)}
                        />
                      </InputContainer>
                    </Section>

                    <Section className="uk-width-1-6@m">
                      <InputContainer>
                        <FormLabel className="uk-form-label">Data de cadastro</FormLabel>
                        <input                                   
                            className="uk-input input"
                            type="date"
                            value={DataCadInicio}                    
                            onChange={e => setDataCadInicio(e.target.value)}
                          />                                               
                      </InputContainer>
                    </Section> 

                    <Section className="uk-width-1-6@m">
                      <InputContainer>
                        <FormLabel className="uk-form-label">Data de envio</FormLabel>
                        <input                                   
                            className="uk-input input"
                            type="date"
                            value={DataCadTermino}                    
                            onChange={e => setDataCadTermino(e.target.value)}
                          />                                               
                      </InputContainer>
                    </Section> 

                    <Section className="uk-width-1-6@m">
                      <InputContainer>
                        <FormLabel className="uk-form-label">Status</FormLabel>  
                          <Select           
                            defaultValue={StatusFiltro}
                            onChange={setStatusFiltro}
                            options={ListaStatus}                                            
                            placeholder={"..."}
                            isLoading={!ListaStatus.length}
                            className="basic-multi-select" 
                            classNamePrefix="uk-select"                                                                              
                          />  
                      </InputContainer>
                    </Section>

                  </Grid>                              
                </CardBody>
              
                <CardFooter>
                  <Grid className="uk-grid-small uk-flex uk-flex-right">
                    <Section>
                      <button
                        type="button"                                            
                        id="Filtrar" 
                        className="uk-button uk-button-primary uk-float-right"                          
                        onClick={() => {GetListaPush("Filtrar", "aguardeFiltro"); SetCurrentPage(1)}}        
                        value="Filtrar"   
                        //disabled={blockFiltro}                   
                      > 
                      <span  uk-icon="icon: search"></span> 
                        Filtrar                                        
                      </button>  

                      <button className="uk-button uk-button-primary" id="aguardeFiltro" style={{display:'none'}}>
                        <span uk-spinner="ratio: 0.5" className="uk-margin-small-right"></span> Aguarde
                      </button>  

                    </Section>
                  </Grid>                                                           
                </CardFooter> 
              </Card>                
            
              { AlertMsg === true && <Alert color={color} content={msg}  duration={time} onHide={() => SetAlertMsg(false)} isClosable /> } 

              <Card className="uk-card-default uk-margin">

                <CardHeader>
                  <Grid className="uk-flex uk-flex-middle">
                    <Section className="uk-width-expand">
                      <h4 className="uk-card-title">Lista de Pushs</h4>
                    </Section>
        
                    <Section className="uk-width-auto">
                      <Grid className="uk-flex uk-flex-right">
                        <Section>
                          <button className="uk-button uk-button-link" type="button" onClick={() => AbreModalCadastroPush()}>
                            <span uk-icon="icon: plus-box"></span> Cadastrar Push
                          </button>
                        </Section>
                        <Section>
                          {LoadingExportar ?
                          <button className="uk-button uk-button-link" type="button" disabled="disabled"><span uk-spinner="ratio: 0.5" className="uk-margin-small-right"></span> Aguarde</button>
                          :
                          <button className="uk-button uk-button-link" type="button" onClick={() => ExportarDados()}> <span uk-icon="icon: cloud-download"></span> Exportar </button>
                          }
                        </Section>
                      </Grid>
                    </Section>
                  </Grid>
                </CardHeader>

            { !ListaPush ?
						<CardBody> <Loading /> </CardBody> 
            :
						<>
							<CardBody className="uk-child-width-expand@s uk-padding-small">
								<Section className="uk-margin-remove uk-padding-small uk-padding-remove-left uk-padding-remove-right">
									<div className="uk-overflow-auto">
										<table className="uk-table uk-table-divider uk-table-striped uk-table-small uk-text-small uk-table-middle  uk-table-hover">                                        
											<thead>
												<tr>  
													<th className="uk-text-left uk-table-shrink">ID</th> 
													<th className="uk-text-left uk-table-expand">Titulo</th> 
													<th className="uk-text-left uk-table-expand">Mensagem</th> 
													<th className="uk-text-left uk-table-expand">Data de cadastro</th> 
													<th className="uk-text-left uk-table-expand">Data de envio</th> 
													<th className="uk-text-left uk-table-shrink">Status</th> 
													<th className="uk-text-left uk-table-shrink">Disparos</th> 
													<th className="uk-text-left uk-table-shrink">Android</th> 
													<th className="uk-text-left uk-table-shrink">iOS</th> 
												</tr>
											</thead>                              
										<tbody>  
										{
											ListaPush.length > 0 ?                              
												ListaPush.map((item, index) => {                                      

													return(                                
														<tr key={index}> 
															<td className="uk-text-nowrap">{item.pushId}</td>
															<td className="uk-text-nowrap">{item.nomeCampanha}</td>
															<td className="uk-text-nowrap">{item.mensagem}</td>
															<td className="uk-text-nowrap">{item.dataCad ? DataHoraFormatada(item.dataCad) : '-'}</td>
															<td className="uk-text-nowrap">{item.dataEnvio ? DataHoraFormatada(item.dataEnvio) : '-'}</td>
															<td><span className="uk-label uk-text-capitalize">{item.statusDescricao}</span></td> 
															<td className="uk-text-nowrap">{item.qtdDisparos}</td>
															<td className="uk-text-nowrap">{item.qtdDisparosAndroid}</td>
															<td className="uk-text-nowrap">{item.qtdDisparosIOS}</td>
														</tr>
													) 
												})
											:
												<tr className="uk-text-center">
													<td colSpan={10}>
													{mensagem}
													</td>
												</tr>
										}                                        
										</tbody>
									</table>
									</div>                          
								</Section>                    
							</CardBody>                          
							{
								ListaPush.length > 0 &&  
								<CardFooter>
									<Grid className="uk-grid-small uk-flex uk-flex-middle uk-flex-right">
									<>
										<Section className="uk-flex uk-flex-middle">                      
										<span className="uk-margin-small-right">Itens por Página:</span>
										<InputContainer className="uk-form-controls">
											<select className="uk-select" id="form-horizontal-select" onChange={(e) => {SetItensPerPage(e.target.value); SetCurrentPage(1)}}>
												<option value={25} selected={itensPerPage === "25" ? "selected" : ""}>25</option>
												<option value={50} selected={itensPerPage === "50" ? "selected" : ""}>50</option>
												<option value={75} selected={itensPerPage === "75" ? "selected" : ""}>75</option>   
												<option value={100} selected={itensPerPage === "100" ? "selected" : ""}>100</option>                                        
											</select>
										</InputContainer>
										</Section>

										<Section>
										<>										

										<ReactPaginate
												nextLabel=" >"                                  
												onClick={(e) => MudaPaginaItens(e)}                                         
												pageRangeDisplayed={3}
												marginPagesDisplayed={1}
												forcePage={currentPage - 1}
												pageCount={pageCount}
												hrefAllControls={true}
												previousLabel="< "
												pageClassName="page-item"
												pageLinkClassName="page-link"
												previousClassName="page-item"
												// previousLinkClassName="page-link"
												nextClassName="page-item"
												// nextLinkClassName="page-link"
												breakLabel="..."
												breakClassName="page-item"
												breakLinkClassName="page-link"
												containerClassName="uk-pagination"
												activeClassName="uk-active"
												renderOnZeroPageCount={null}
											/>
										</>
										</Section>
									</> 
									</Grid>                                   
								</CardFooter>
							}
						</>
            }
              </Card>
        
          </Section>
        </main>
      </Container>  

      <Modal isOpen={ModalCadastroPush} id="lg" centered>
        <ModalHeader>Cadastro de Push</ModalHeader>

        <ModalBody>
          <Grid className="uk-grid-small">

            <Section className="uk-width-1-1@m">
              <InputContainer>
                <FormLabel className="uk-form-label">Data de agendamento <span className="uk-text-danger">*</span></FormLabel>
                  <input                                   
                      className="uk-input input"
                      type={'datetime-local'}
                      value={DadosCadastro?.dataEnvio || ''}                    
                       onChange={e => setDadosCadastro({ ...DadosCadastro, dataEnvio: e.target.value })}
                    />  
              </InputContainer>
            </Section>

            <Section className="uk-width-1-2@m">
              <InputContainer>
                <FormLabel className="uk-form-label">Título <span className="uk-text-danger">*</span></FormLabel>
                <input
                  className="uk-input input"
                  placeholder='Título'
                  type="text"
                  value={DadosCadastro?.titulo || ''}
                  onChange={e => setDadosCadastro({ ...DadosCadastro, titulo: e.target.value })} />
              </InputContainer>
            </Section>

            <Section className="uk-width-1-2@m">
              <InputContainer>
                <FormLabel className="uk-form-label">Mensagem <span className="uk-text-danger">*</span></FormLabel>
                <input
                  className="uk-input input"
                  placeholder='Mensagem'
                  type="text"
                  value={DadosCadastro?.mensagem || ''}
                  onChange={e => setDadosCadastro({ ...DadosCadastro, mensagem: e.target.value })} />
              </InputContainer>
            </Section>

            <Section className="uk-width-1-1@m">
              <hr className="uk-divider-icon"></hr>
            </Section>

            <Section className="uk-width-1-1@m">
              <InputContainer>
                <FormLabel className="uk-form-label">Profissões <small>(Caso nenhuma profissão seja selecionada, consideramos todas as profissões)</small></FormLabel>
                
                <div className="ListaCheckbox">
                {ListaProfissoes.length > 0 &&
                  ListaProfissoes.map((item, index) => {
                    return (
                      <div key={index}>
                        <input
                          type="checkbox"
                          className={'uk-checkbox'}
                          value={item.value}
                          id={item.value}
                          name={item.value}
                          checked={ListaProfissoesSelecionadas.includes(item.value) ? true : false}
                          onChange={(e) => {
                            if (ListaProfissoesSelecionadas.includes(item.value)) {
                              setListaProfissoesSelecionadas(ListaProfissoesSelecionadas.filter(d => d !== item.value))
                            } else {
                              setListaProfissoesSelecionadas([...ListaProfissoesSelecionadas, item.value])
                            }
                          }}
                        /> <label htmlFor={item.value} className="uk-button uk-button-link">{item.label}</label>
                      </div>
                    )                          
                  })
                }
                </div>

              </InputContainer>
            </Section>

            <Section className="uk-width-1-1@m">
              <InputContainer>
                <FormLabel className="uk-form-label">Estados <small>(Caso nenhum estado seja selecionado, consideramos todos os estados)</small></FormLabel>
                
                <div className="ListaCheckbox">
                {ListaEstados.length > 0 &&
                  ListaEstados.map((item, index) => {
                    return (
                      <div key={index}>
                        <input
                          type="checkbox"
                          className={'uk-checkbox'}
                          value={item.value}
                          checked={ListaEstadosSelecionados.includes(item.value) ? true : false}
                          id={item.value}
                          name={item.value}
                          onChange={(e) => {
                            if (ListaEstadosSelecionados.includes(item.value)) {
                              setListaEstadosSelecionados(ListaEstadosSelecionados.filter(d => d !== item.value))
                            } else {
                              setListaEstadosSelecionados([...ListaEstadosSelecionados, item.value])
                            }
                          }}
                        /> <label htmlFor={item.value} className="uk-button uk-button-link">{item.label}</label>
                      </div>
                    )                          
                  })
                }
                </div>
                
                
              </InputContainer>
            </Section>

                
          </Grid>
        </ModalBody>

        <ModalFooter>
          <Grid className="uk-grid-small uk-flex uk-flex-right">
            <Section>
              <button
                type="button"
                id='btn-fechar-cadastro'
                className="uk-button uk-button-danger"
                onClick={() => { FechaModalCadastroPush() }}
              >
                <span uk-icon="icon: close"></span> Fechar
              </button>
            </Section>
            <Section>
              <button
                type="button"
                id="btn-envia-formulario"
                className="uk-button uk-button-primary"
                onClick={() => CadastrarPush()}
              >
                <span uk-icon="icon: check"></span> Cadastrar
              </button>

              <button className="uk-button uk-button-primary" id="btn-envia-formulario-loading" >
                <span uk-spinner="ratio: 0.5" className="uk-margin-small-right"></span> Aguarde
              </button>
            </Section>
          </Grid>
        </ModalFooter>
      </Modal>

    </Cont>
  );
}

export default Push;
